module.exports = __webpack_public_path__ + "assets/media/videoSample1.8cd0e9af.mp4";